import React, { useState, useMemo, useEffect } from "react";

import { ApiService } from "../../utils/ApiService";
import Pagination from "../../common/Pagination";
import { Avatar, formatDateTime } from "../../common/Functions";
import SearchComponent from "../../components/SearchComponent";
import { showToast } from "../../common/Toast";
import HostDashboard from "../HostDetail";
import FullPageLoader from "../../common/FullPageLoader";
import { capitalizeEachWord } from "../../utils/common";

const HostManagement = () => {
  const [hostData, setHostData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({});
  const [selectedHost,setSelectedHost] = useState({});
  const [loading, setloading] = useState(false);


  useEffect(() => {
    fetchHostData(page, limit,search)
  }, [])


  const fetchHostData = async (currentPage, currentLimit, search) => {
    const params = {
      userRole: "HOST",
      page: currentPage,
      limit: currentLimit
    }
    if (search?.trim()) {
      params.keyword = search;
    }
    try {
      setloading(true)
     const queryString = new URLSearchParams(params).toString();
      const res = await ApiService.get(`admin/user-list?${queryString}`);

      if (res.success) {
        setHostData(res.user || []);
        setPagination(res.pagination);
      }
    } catch (error) {
      console.log("host error", error);
    }finally{
      setloading(false)
    }
  };

  // Toggle Status
  const handleStatus = async (id,status) => {
    try {
      let params = {
        "userId":id,
    "status":!status
      }
      const res = await ApiService.post(`admin/enable-disable-user`,params)
      console.log(res)
      if(res.success){
         showToast.success(res.message)
       fetchHostData(page,limit)
      }else{
        showToast.error(res.message)
      }
    } catch (error) {
      
    }
    // setHostData((prev) =>
    //   prev.map((x) => (x.id === id ? { ...x, active: !x.active } : x))
    // );
  };
  const handlePagination = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPage(newPage);
      fetchHostData(newPage, limit, search);
    }
  }

  const handleSearch= (e)=>{
    const value = e.target.value
      if (value.startsWith(" ")) return;
    setSearch(value)
    setPage(1)
    fetchHostData(1,limit,e.target.value)
  }

  const startingIndex = (page - 1) * limit;
  return (
    <>
    {loading && <FullPageLoader/>}
        <div className="flex-grow bg-gray-100  px-6 pb-2 w-full overflow-auto h-[90vh]">

          {!selectedHost?._id &&  
            <div className="mb-6">
              <SearchComponent search={search} onChange={handleSearch} placeholder="Search by name, email..." />
            </div>
          }
          {selectedHost?._id ? <HostDashboard host={selectedHost} events={hostData} setSelectedHost={setSelectedHost} />:
          <>
            <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
              <table className="w-full text-center">
                <thead className="bg-gray-200 text-black">
                  <tr>
                    <th className="p-4 text-left font-normal">S.No</th>
                    <th className="p-4 text-left font-normal">Name</th> {/* <-- left aligned header */}
                    <th className="p-4 text-left font-normal">Email</th>
                    <th className="p-4 text-left font-normal">Member Since</th>
                    <th className="p-4 text-left font-normal">Total Events Posted</th>
                    {/* <th className="p-4 text-left font-normal">Membership</th> */}
                    <th className="p-4 text-center font-normal">Actions</th>
                  </tr>
                </thead>

                {/* Table body */}
                <tbody>
                  {hostData.map((host, index) => (
                    <tr key={host._id} className="border-t" >
                      <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{String(startingIndex + index + 1).padStart(2, "0")}</td>

                      {/* <-- Important: LEFT aligned cell with flex row for avatar + name */}
                      <td className="p-4" >
                        <div className="flex items-center gap-3">
                          {/* Avatar: circle, fixed size, object-cover if image */}

                          <Avatar name={host.name} image={host.image} size={32}/>


                          {/* Name text */}
                          <div 
                            className="text-sm text-[#4C4C4C] hover:text-gray-800 cursor-pointer"
                            onClick={() => setSelectedHost(host)}
                          >
                            {capitalizeEachWord(host.name)}
                          </div>
                        </div>
                      </td>

                      <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{host.email}</td>
                      <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{formatDateTime(host.createdAt) || "--"}</td>
                      <td className="p-4 text-left text-[#4C4C4C] font-normal text-sm">{String(host.hostEventCount || 0).padStart(2, "0")}</td>
                      <td className="p-4 text-center align-middle">
                        <button
                          onClick={() => handleStatus(host._id, host.status)}
                          className={`relative inline-block w-8 h-4 rounded-full transition ${
                            host.status ? "bg-green-500" : "bg-gray-300"
                          }`}
                        >
                          <span
                            className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition ${
                              host.status ? "translate-x-4" : ""
                            }`}
                          />
                        </button>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>

              {hostData.length === 0 && (
                <p className="text-center py-10 text-gray-500">
                  No results found
                </p>
              )}
            </div>
            <Pagination
              page={page}
              totalPages={pagination.totalPages}
              totalItems={pagination.totalUser}
              limit={limit}
              onPageChange={(newPage) => handlePagination(newPage)}
            />
            </>}
        </div>
 </> );
};

export default HostManagement;
